import { camelCase, isNil } from 'lodash-es'
import { memo } from 'react'
import useTheme from 'd2/hooks/useTheme'
import type { Props } from './types'

const BrandingLogo = memo<Props>(({
  className,
  variant,
}) => {
  const { branding } = useTheme()
  const src = isNil(variant)
    ? branding?.navLogoUrl
    // TODO: Remove 'as' type assertions because they are unsafe.
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    : branding?.[camelCase(`logoUrl_${variant}`) as keyof typeof branding] as string | undefined

  if (!src) return null

  return (
    <img
      alt={branding?.name ? `${branding.name} Logo` : 'Logo'}
      className={className}
      data-test-id='BrandingLogo'
      src={src}
    />
  )
})

BrandingLogo.displayName = 'BrandingLogo'

export default BrandingLogo
